export default "__VITE_ASSET__0aef78f2__"